<div
	class="modal-dialog goreact-modal activity-preview-dialog">
	<div class="modal-content activity-preview-dialog__content"
		cdkTrapFocus
		goDialogContent
		[goDialogContentAriaLabelledBy]="dialogTitleId">
		<header class="activity-preview-dialog__header">
			<h2 class="activity-preview-dialog__title" [id]="dialogTitleId" translate="activity-preview-modal-title"></h2>
			<button
				type="button"
				class="activity-preview-dialog__close-button btn-none"
				[attr.aria-label]="'common_close' | translate"
				(click)="close()">
				<i class="ficon-app-x" aria-hidden="true"></i>
			</button>
		</header>

		<div class="activity-preview-dialog__mobile-section-field">
			<mat-form-field appearance="outline" class="activity-preview-dialog__mobile-section-control">
				<mat-label translate="activity-preview-modal-mobile-current-section"></mat-label>
				<mat-select
					[id]="sectionSelectId"
					[value]="selectedSection()"
					[attr.aria-controls]="activePanelId()"
					(selectionChange)="onSectionSelect($event)">
					@for (section of sections; track section.value) {
						<mat-option [value]="section.value">{{ section.label }}</mat-option>
					}
				</mat-select>
				<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
			</mat-form-field>
		</div>

		<div class="activity-preview-dialog__layout">
			<nav class="activity-preview-dialog__rail" [attr.aria-label]="'activity-preview-modal-sections' | translate">
				<ul class="activity-preview-dialog__section-list">
					@for (section of sections; track section.value) {
						<li class="activity-preview-dialog__section-item">
							<button
								type="button"
								class="activity-preview-dialog__section-button"
								[class.active]="isSectionSelected(section.value)"
								[attr.aria-current]="isSectionSelected(section.value) ? 'page' : null"
								[attr.aria-controls]="sectionPanelId(section.value)"
								(click)="selectSection(section.value)">
								{{ section.label }}
							</button>
						</li>
					}
				</ul>
			</nav>

			<section
				class="activity-preview-dialog__main"
				[id]="activePanelId()"
				[attr.aria-label]="selectedSectionLabel()">
				@switch (selectedSection()) {
					@case ('details') {
						<h3 translate="nav-header_details"></h3>
						<div class="activity-preview-dialog__details-list">
							<p>
								<strong>{{ 'activity-preview-modal-details-name' | translate}} </strong>
								<span>{{ activity.name }}</span>
							</p>
							<p class="activity-preview-dialog__details-spacer">
								<strong>{{ 'common_type' | translate }}: </strong>
								<span class="activity-type">{{ activityTypeLabel() }}</span>
							</p>
							<p>
								<strong>{{ 'activity-preview-modal-details-attempts' | translate }} </strong>
								<span>
									{{ activity.has_single_recording_attempt
										? ('common_single' | translate)
										: ('common_unlimited' | translate) }}
								</span>
							</p>
							<p class="activity-preview-dialog__details-spacer">
								<strong>{{ 'library-collections_details-creator' | translate }} </strong>
								<span class="creator-name">{{ creatorName() }}</span>
							</p>
							<p>
								<strong>{{ 'library-collections_details-creation-date' | translate }} </strong>
								<span class="creator-date">{{ creationDate() | date: 'mediumDate' }}</span>
							</p>
						</div>
					}
					@case ('tasks') {
						<h3 translate="activity-task-pane-title"></h3>
						<ul class="activity-preview-dialog__stack">
							@for (task of tasks; track task.id !== 0 ? task.id : task.type) {
								<li class="activity-preview-dialog__task">
									<h4>{{ taskTitle(task) }}</h4>
									@if (taskInstructionText(task); as instructionText) {
										<div
											class="activity-preview-dialog__html-text"
											[innerHTML]="instructionText">
										</div>
									}
									@if (taskInstructionMedia(task); as mediaItem) {
										<div class="activity-preview-dialog__media-row">
											<ngx-media-thumbnail
												class="activity-preview-dialog__media-thumbnail activity-preview-dialog__media-thumbnail--task"
												[media]="mediaItem.media">
											</ngx-media-thumbnail>
											<span class="activity-preview-dialog__media-title">{{ mediaItem.title }}</span>
										</div>
									}
								</li>
							}
						</ul>
					}
					@case ('rubrics') {
						@if (rubrics().length > 0) {
							<ul class="activity-preview-dialog__rubrics">
								@for (rubric of rubrics(); track rubric.heading + rubric.id) {
									<li class="activity-preview-dialog__rubric">
										<div class="activity-preview-dialog__inline-heading">
											<h3>{{ rubric.heading }}</h3>
											<button
												type="button"
												class="activity-preview-dialog__link-button btn-none"
												[attr.aria-label]="'activity-preview-modal-view-details-aria-label' | translate: {rubric: rubric.heading}"
												(click)="previewRubric(rubric)" translate="activity-preview-modal-view-details">
											</button>
										</div>
										<h4 class="activity-preview-dialog__rubric-title">{{ rubric.title }}</h4>
										<div class="activity-preview-dialog__rubric-summary">
											<ul class="activity-preview-dialog__rubric-groups">
												@for (group of rubric.groups; track group.id) {
													<li class="activity-preview-dialog__rubric-group">
														@if (group.title != null) {
															<h5 class="activity-preview-dialog__category-title">{{ group.title }}</h5>
														}
														<ul
															class="activity-preview-dialog__rubric-items"
															[class.activity-preview-dialog__rubric-items--nested]="group.items.length > 1">
															@for (item of group.items; track item.id) {
																<li class="activity-preview-dialog__rubric-item">
																	<p class="activity-preview-dialog__rubric-item-title">
																		<strong>{{ item.title }}:</strong>
																		<span> {{ item.total === 0 ? '-' : item.total }}</span>
																	</p>
																</li>
															}
														</ul>
														@if (group.total != null) {
															<p class="activity-preview-dialog__category-total">
																<strong translate="activity-preview-modal-rubrics-category-points"></strong>
																<span> {{ group.total }}</span>
															</p>
														}
													</li>
												}
											</ul>
											@if (rubric.total != null) {
												<p class="activity-preview-dialog__rubric-total">
													<strong translate="activity-preview-modal-rubrics-total-points"></strong>
													<span> {{ rubric.total }}</span>
												</p>
											}
										</div>
									</li>
								}
							</ul>
						} @else {
							<p class="activity-preview-dialog__empty" translate="activity-preview-modal-rubrics-no-rubrics-added"></p>
						}
					}
					@case ('markers') {
						<div class="activity-preview-dialog__stack">
							<section>
								<h3 translate="activity-view_setting-indicator-preview-marker-set"></h3>
								@if (markerSet(); as selectedMarkerSet) {
									@if (selectedMarkerSet.title != null && selectedMarkerSet.title !== '') {
										<p>{{ selectedMarkerSet.title }}</p>
									}
									@if (selectedMarkerSet.tags.length > 0) {
										<marker-display
											class="activity-preview-dialog__marker-display"
											[markers]="selectedMarkerSet.tags"
											[withName]="true">
										</marker-display>
									}
								} @else {
									<p class="activity-preview-dialog__empty" translate="activity-preview-modal-markers-no-markers-added"></p>
								}
							</section>

							<section>
								<h3 translate="activity-preview-modal-ai-marker-set"></h3>
								@if (aiMarkers().length > 0) {
									<marker-display
										class="activity-preview-dialog__marker-display"
										[aiStyle]="true"
										[markers]="aiMarkers()"
										[withName]="true">
									</marker-display>
								} @else {
									<p class="activity-preview-dialog__empty" translate="activity-preview-modal-ai-marker-set-no-markers"></p>
								}
							</section>
						</div>
					}
					@case ('ownerAttachments') {
						<h3 translate="activity-editor_activity-resources"></h3>
						@if (ownerMediaItems().length > 0) {
							<ul class="activity-preview-dialog__stack activity-preview-dialog__stack--compact">
								@for (mediaItem of ownerMediaItems(); track mediaItem.media.media_id ?? mediaItem.title) {
									<li class="activity-preview-dialog__media-row">
										<ngx-media-thumbnail
											class="activity-preview-dialog__media-thumbnail activity-preview-dialog__media-thumbnail--owner"
											[media]="mediaItem.media">
										</ngx-media-thumbnail>
										<span class="activity-preview-dialog__media-title">{{ mediaItem.title }}</span>
									</li>
								}
							</ul>
						} @else {
							<p class="activity-preview-dialog__empty" translate="activity-preview-modal-owner-attachments-no-attachment"></p>
						}
					}
				}
			</section>
		</div>
	</div>
</div>
